/* eslint-disable arrow-body-style */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
import { useState, useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import adminServices from "../../../services/adminServices";
import Page from "../../../components/Page";


// const TIERS = ["All", "Free", "Basic", "Professional", "Premium"];
const getTierPriority = (planName = '') => {
  if (!planName) return -1;
  if (planName.startsWith('platform:')) {
    const tier = planName.split(':')[1];
    if (tier === 'PREMIUM') return 6;
    if (tier === 'PRO') return 5;
    if (tier === 'BASIC') return 4;
  }
  if (planName.startsWith('category:')) {
    const tier = planName.split(':')[1]; // e.g. "CLAT PREMIUM"
    if (tier.includes('PREMIUM')) return 3;
    if (tier.includes('PRO')) return 2;
    if (tier.includes('BASIC')) return 1;
  }
  if (planName === 'COURSE') return 0;
  return -1;
};

const getDisplayLabel = (planName = '') => {
  if (!planName) return 'Free';
  if (planName.includes(':')) return planName.split(':')[1]; 
  return planName; 
};

const resolveTopPlan = (planName = '') => {
  if (!planName) return null;
  const plans = planName.split(',').map(p => p.trim());
  plans.sort((a, b) => getTierPriority(b) - getTierPriority(a));
  return plans[0] || null;
};

const TIERS = ["All", "BASIC", "PRO", "PREMIUM"];
const TIER_DISPLAY = { "BASIC": "Basic", "PRO": "Pro", "PREMIUM": "Premium" };

const SORTABLE_FIELDS = { "JOINED": "createDateTime", "LAST ACTIVE": "last_login" };

const getName = (u) => u?.firstName && u?.lastName ? `${u.firstName} ${u.lastName}` : u?.name || "—";
const getEmail = (u) => u?.email || "—";
const getTier = (u) => u?.subscriptionPlan || u?.tier || "Free";
const getStatus = (u) => u?.computedStatus === u?.statusDescription ? u?.statusDescription
: u?.statusDescription === 'Active' &&  u?.computedStatus === "Inactive" ? 'Inactive' :
u?.computedStatus === "Deleted" ?  "Deleted":
u?.computedStatus === "Suspended" ?  "Suspended":
 'Unverified'


const getLastActive = (u) => {
  const val = u?.last_login;
  return val ? moment.utc(val).format("LL") : "—";
};

const getJoined = (u) => {
    const val = u?.createDateTime || u?.joined;
    return val ? moment.utc(val).format("LL") : "—";
};

const getLastActiveDateTime = (u) => {
  const val = u?.last_login;
  return val ? moment.utc(val).format("LLL") : "—";
};
const getJoinedDateTime = (u) => {
  const val = u?.createDateTime || u?.joined;
  return val ? moment.utc(val).format("LLL") : "—";
};

const getLocation = (u) => {
  const parts = [u?.city, u?.state, u?.country].filter(Boolean);
  if (parts.length > 0) return parts.join(', ');
  return u?.location || u?.address || '—';
};

export default function B2CUsers() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState("All");
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  const [userFilter, setUserFilter] = useState("All");
  const [downloading, setDownloading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [clientList, setClientList] = useState([]);
  const [individualList, setIndividualList] = useState([]);
  const [count, setCount] = useState({});
  const [sortField, setSortField] = useState("createDateTime");
  const [sortOrder, setSortOrder] = useState("desc"); 
  

  const statusStyle = {
    Active: "text-green-600",
    Inactive: "text-orange-400",
    Unverified: "text-red-400",
    Suspended: "text-red-500",
    Deleted: "text-red-500",
  };

  const [tierCounts, setTierCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const handleTabChange = (tier) => {
    setActiveTab(tier);
    setPage(1);
  };
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const rowsPerPage = 10;

  const handleDateChange = (setter) => (e) => {
    setter(e.target.value);
    setPage(1);
  };

  const handleSort = (label) => {
    const field = SORTABLE_FIELDS[label];
    if (!field) return;
    if (sortField === field) {
      setSortOrder((prev) => (prev === "desc" ? "asc" : "desc"));
    } else {
      setSortField(field);
      setSortOrder("desc");
    }
    setPage(1);
  };

  const escapeCsv = (val) => {
    if (val === null || val === undefined) return '""';

    const str = String(val);
    return `"${str.replace(/"/g, '""')}"`;
  };

  const handleDownload = async () => {
    setDownloading(true);
    try {
     const response = await adminServices.getIndividualListDownload(
        sortOrder,
        sortField,
        search,
        statusFilter === 'All' ? null : statusFilter,
        null, 
        fromDate || null,
        toDate || null,
        userFilter === 'All' ? null : userFilter,
        "list"
      );

      if (!response.ok) {
        console.error('Download fetch failed', response);
        return;
      }

      const rows = response.data?.records || [];

      const headers = ["Name", "Email", "Phone", "Location", "Tier", "Courses", "Status", "Last Active", "Joined"];
      const csvRows = [headers.map(escapeCsv).join(',')];

      rows.forEach((user) => {
        const topPlan = resolveTopPlan(user?.planName);
        const courseCount = Array.isArray(user?.allCourses) ? user.allCourses.length : 0;
        csvRows.push([
          escapeCsv(user?.firstName && user?.lastName ? `${user.firstName} ${user.lastName}` : user?.name || "—"),
          escapeCsv(getEmail(user)),
          escapeCsv(user?.phone || ''),
          escapeCsv(user?.location ? getLocation(user) : '-'),
          escapeCsv(getDisplayLabel(topPlan) || 'Free'),
          escapeCsv(courseCount),
          escapeCsv(getStatus(user)),
          escapeCsv(getLastActiveDateTime(user)),
          escapeCsv(getJoinedDateTime(user)),
        ].join(','));
      });

      const csvContent = csvRows.join('\n');
      const blob = new Blob([`\uFEFF${csvContent}`], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      const dateSuffix = fromDate || toDate
        ? `_${fromDate || 'start'}_to_${toDate || 'now'}`
        : '';
      link.href = url;
      link.setAttribute('download', `b2c_users${dateSuffix}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download error', err);
    } finally {
      setDownloading(false);
    }
  };

  const getClientLists = async () => {
    setLoading(true);
    try {
      const response = await adminServices.getIndividualList(
        page, rowsPerPage, sortOrder, sortField, search,
        statusFilter === 'All' ? null : statusFilter,
        fromDate || null,
        toDate || null,
        userFilter === 'All' ? null : userFilter
      );
      if (response.ok) {
        setClientList(response.data?.records || []);
        setPageCount(response.data?.metadata?.totalRecordCount || 0);
        if (response.data?.metadata?.tierCounts) {
          setTierCounts(response.data.metadata.tierCounts);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    const t = setTimeout(() => { setSearch(searchInput); setPage(1); }, 400);
    return () => clearTimeout(t);
  }, [searchInput]);

  useEffect(() => {
    setPage(1);
    getClientLists();
  }, [statusFilter, fromDate, toDate, sortField, sortOrder,userFilter]);

  useEffect(() => {
    getClientLists();
  }, [search, page]);

  useEffect(() => {
    getAvailableTiers();
  }, []);

  useEffect(() => {
    if (activeTab !== 'All') {
      getClientListsIndividual();
    }
  }, [activeTab, statusFilter, search, fromDate, toDate, sortField, sortOrder]);

  const getClientListsIndividual = async () => {
    setLoading(true);
    try {
      const response = await adminServices.getIndividualListByPlan(
        page, 500, sortOrder, sortField, search,
        statusFilter === 'All' ? null : statusFilter,
        activeTab === 'All' ? null : activeTab,
        fromDate || null,
        toDate || null,
        userFilter === 'All' ? null : userFilter
      );
      if (response.ok) {
        setIndividualList(response.data?.records || []);
        const planCounts = response.data?.metadata?.planCounts || {};
        setCount(planCounts);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const getAvailableTiers = async () => {
    try {
      const response = await adminServices.getIndividualListByPlan(
        1, 1, "desc", "createDateTime", "", "Active", null
      );
      if (response.ok) {
        const planCounts = response.data?.metadata?.planCounts || {};
        setCount(planCounts);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const totalPages = Math.ceil(pageCount / rowsPerPage);

  const tierBadgeCount = (tier) => {
    if (tier === "All") return pageCount;
    return Object.entries(count || {})
      .filter(([key]) => key.includes(tier))
      .reduce((sum, [, val]) => sum + Number(val), 0);
  };

  const getCount = (activeTab, count) =>
    count?.[activeTab] ?? 0;


  const getPaginationPages = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    if (page <= 4) return [1, 2, 3, 4, 5, "…", totalPages];
    if (page >= totalPages - 3) return [1, "…", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    return [1, "…", page - 1, page, page + 1, "…", totalPages];
  };

  const handleNavigateView = (data) => {
    navigate('/app/individual-usersview', { state: data })
  }

  const clearDateFilter = () => {
    setFromDate("");
    setToDate("");
    setPage(1);
  };


  const TableAll = ["NAME", "EMAIL", "PHONE", "ONBOARD", "TIER", "COURSES", "STATUS", "LAST ACTIVE", "JOINED", ""]
  const TablePlan = ["NAME", "EMAIL", "PHONE", "TIER", "STATUS", "LAST ACTIVE", "JOINED", ""]

  const getPlanColor = (planName = '') => {
    if (!planName) return { color: '#6B7280', bg: '#F3F4F6' };
    if (planName.includes('PREMIUM')) return { color: '#B45309', bg: '#FEF3C7' };
    if (planName.includes('PRO')) return { color: '#7C3AED', bg: '#EDE9FE' };
    if (planName.includes('BASIC')) return { color: '#1D4ED8', bg: '#EFF6FF' };
    if (planName === 'COURSE') return { color: '#0F766E', bg: '#F0FDFA' };
    return { color: '#6B7280', bg: '#F3F4F6' };
  };
  const PLAN_BADGE_CLASS = "inline-block text-[11px] font-semibold px-2.5 py-1 rounded-full whitespace-nowrap w-[100px] text-center overflow-hidden text-ellipsis";

  return (
    <Page title="users">
      <div className="min-h-screen bg-gray-50 font-sans px-8 py-8">

        <div className="mb-5">
          <h1 className="text-xl font-semibold text-gray-800">B2C Users</h1>
          <p className="text-sm text-gray-400 mt-0.5">
            Direct learners — subscriptions, assessment performance, and course progress.
          </p>
        </div>

        <div className="flex gap-1 border-b border-gray-200 mb-5">
          {TIERS.map((tier) => (
            <button key={tier} onClick={() => handleTabChange(tier)}
              className={`px-3 pb-2.5 pt-1 text-sm font-medium flex items-center gap-1.5 border-b-2 transition-colors ${activeTab === tier
                ? "border-blue-500 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700"
                }`}
            >
              {TIER_DISPLAY[tier] || tier}
              <span className={`text-xs font-semibold rounded px-1 ${activeTab === tier ? "text-blue-600" : "text-gray-400"}`}>
                {tierBadgeCount(tier)}
              </span>
            </button>
          ))}
        </div>

        {activeTab === 'All' &&
          <div className="flex items-center gap-3 mb-5">
            <div className="relative">
              <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <circle cx="11" cy="11" r="8" strokeWidth="2" />
                <path d="M21 21l-4.35-4.35" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <input
                type="text"
                placeholder="Search name or email..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                className="pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 w-56 placeholder-gray-400"
              />
            </div>

            <div className="relative">
              <select value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="appearance-none pl-3 pr-8 py-2 text-sm border border-gray-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 text-gray-600 cursor-pointer"
              >
                <option value='All' key='All'>All Status</option>
                <option value='Active' key='Active'>Active</option>
                <option value='Inactive' key='Inactive'>Inactive</option>
                <option value='Suspended' key='Suspended'>Suspended</option>
                <option value='Deleted' key='Deleted'>Deleted</option>
              </select>
              <svg className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

               <div className="relative">
              <select value={userFilter}
                onChange={(e) => setUserFilter(e.target.value)}
                className="appearance-none pl-3 pr-8 py-2 text-sm border border-gray-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 text-gray-600 cursor-pointer"
              >
                <option value='All' key='All'>User Details</option>
                <option value='1' key='Internal'>Internal Users</option>
                
              </select>
              <svg className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            {/* NEW: sort selector (redundant with clickable headers, useful on mobile) */}
            <div className="relative">
              <select
                value={`${sortField}:${sortOrder}`}
                onChange={(e) => {
                  const [field, order] = e.target.value.split(':');
                  setSortField(field);
                  setSortOrder(order);
                  setPage(1);
                }}
                className="appearance-none pl-3 pr-8 py-2 text-sm border border-gray-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 text-gray-600 cursor-pointer"
              >
                <option value="createDateTime:desc">Joined (Newest)</option>
                <option value="createDateTime:asc">Joined (Oldest)</option>
                <option value="last_login:desc">Last Active (Newest)</option>
                <option value="last_login:asc">Last Active (Oldest)</option>
              </select>
              <svg className="absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M6 9l6 6 6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            {/* NEW: date range filter */}
            <div className="flex items-center gap-2">
              <input
                type="date"
                value={fromDate}
                max={toDate || undefined}
                onChange={handleDateChange(setFromDate)}
                className="pl-3 pr-2 py-2 text-sm border border-gray-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 text-gray-600"
              />
              <span className="text-xs text-gray-400">to</span>
              <input
                type="date"
                value={toDate}
                min={fromDate || undefined}
                onChange={handleDateChange(setToDate)}
                className="pl-3 pr-2 py-2 text-sm border border-gray-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 text-gray-600"
              />
              {(fromDate || toDate) && (
                <button
                  onClick={clearDateFilter}
                  className="text-xs text-gray-400 hover:text-blue-600 underline"
                >
                  Clear
                </button>
              )}
            </div>
            <button
              onClick={handleDownload}
              disabled={downloading || pageCount === 0}
              className="flex items-center gap-1.5 px-3 py-2 text-sm border border-gray-200 rounded-md bg-white text-gray-600 hover:border-blue-300 hover:text-blue-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path d="M12 3v12m0 0l-4-4m4 4l4-4M4 21h16" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              {downloading ? 'Preparing…' : 'Download CSV'}
            </button>
          </div>}

        <div className="bg-white rounded-xl border border-gray-200 overflow-x-auto shadow-sm">

          <table className="w-full min-w-[900px] text-sm">
            <thead>
              <tr className="border-b border-gray-100 bg-gray-50/60">
                {(activeTab === 'All' ? TableAll : TablePlan).map((h, i) => {
                  const field = SORTABLE_FIELDS[h];
                  const isSorted = field && sortField === field;
                  return (
                    <th
                      key={i}
                      onClick={field ? () => handleSort(h) : undefined}
                      className={`px-5 py-3.5 text-left text-xs font-semibold tracking-wider uppercase whitespace-nowrap ${i === TableAll.length - 1 ? 'w-px' : ''
                        } ${field ? 'cursor-pointer select-none hover:text-blue-600' : ''} ${isSorted ? 'text-blue-600' : 'text-gray-400'
                        }`}
                    >
                      <span className="inline-flex items-center gap-1">
                        {h}
                        {field && (
                          <span className="text-[10px] leading-none">
                            {isSorted ? (sortOrder === 'desc' ? '▼' : '▲') : '↕'}
                          </span>
                        )}
                      </span>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: rowsPerPage }).map((_, i) => (
                  <tr key={i} className="border-b border-gray-50">
                    <td className="px-5 py-4">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-gray-100 animate-pulse shrink-0" />
                        <div className="h-3 bg-gray-100 rounded animate-pulse w-28" />
                      </div>
                    </td>
                    {Array.from({ length: activeTab === 'All' ? 6 : 5 }).map((__, j) => (
                      <td key={j} className="px-5 py-4">
                        <div className="h-3 bg-gray-100 rounded animate-pulse w-3/4" />
                      </td>
                    ))}
                    <td className="px-5 py-4">
                      <div className="h-6 bg-gray-100 rounded animate-pulse w-12 ml-auto" />
                    </td>
                  </tr>
                ))
              ) : clientList.length === 0 ? (
                <tr>
                  <td colSpan={7} className="text-center py-16 text-gray-400 text-sm">
                    No users match your filters.
                  </td>
                </tr>
              ) : (
                activeTab === 'All' ?
                  clientList.map((user, idx) => {
                    const name = getName(user);
                    const tier = getTier(user);
                    const status = getStatus(user);
                    const topPlan = resolveTopPlan(user?.planName);
                    const { color: topColor, bg: topBg } = getPlanColor(topPlan);


                    return (
                      <tr
                        key={user.id || user._id || idx}
                        className={`border-b border-gray-50 hover:bg-blue-50/30 transition-colors ${idx === clientList.length - 1 ? "border-b-0" : ""}`}
                      >
                        <td className="px-5 py-3.5">
                          <div className="flex items-center gap-3">
                            <span className="font-medium text-gray-800">{name}</span>
                          </div>
                        </td>

                        <td className="px-5 py-3.5 text-gray-500 max-w-[200px]">
                          <span className="truncate block">{getEmail(user)}</span>
                        </td>
                        <td className="px-5 py-3.5 text-gray-500 max-w-[200px]">
                          <span className="truncate block">{user?.phone ? user?.phone : '-'}</span>
                        </td>
                        <td className="px-5 py-3.5 text-gray-500 max-w-[200px]">
                          <span className="truncate block">{user?.assessment && user?.assessment?.length > 0 ? user?.assessment[0].description : '-'}</span>
                        </td>

                        <td className="px-5 py-3.5 w-[150px]">
                          <span className={PLAN_BADGE_CLASS} style={{ color: topColor, backgroundColor: topBg }}>
                            {getDisplayLabel(topPlan) || 'Free'}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 w-[100px]">
                          {Array.isArray(user?.allCourses) && user?.allCourses?.length > 0 ? (
                            <span className="text-xs font-semibold px-2 py-0.5 rounded bg-green-50 text-green-700 whitespace-nowrap">
                              {user?.allCourses?.length} {user?.allCourses?.length === 1 ? "course" : "courses"}
                            </span>
                          ) : (
                            <span className="text-xs text-gray-400">—</span>
                          )}
                        </td>

                        <td className="px-5 py-3.5">
                          <span className={`font-medium ${statusStyle[status] || "text-gray-500"}`}>
                            {status}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 text-gray-500 whitespace-nowrap">{getLastActive(user)}</td>
                        <td className="px-5 py-3.5 text-gray-500 whitespace-nowrap">{getJoined(user)}</td>
                        <td className="px-5 py-3.5">
                          <button
                            onClick={() => handleNavigateView(user)}
                            className="text-xs border border-blue-300 text-blue-600 bg-white rounded px-3 py-1.5 hover:border-blue-400 hover:bg-blue-100 transition-colors font-medium"
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    );
                  })
                  :
                  individualList && individualList?.length > 0 && individualList?.map((user, idx) => {
                    const name = getName(user);
                    const tier = getTier(user);
                    const status = getStatus(user);
                    const { color, bg } = getPlanColor(user?.planName);
                    return (
                      <tr
                        key={user.id || user._id || idx}
                        className={`border-b border-gray-50 hover:bg-blue-50/30 transition-colors ${idx === clientList.length - 1 ? "border-b-0" : ""}`}
                      >
                        <td className="px-5 py-3.5">
                          <div className="flex items-center gap-3">
                            <span className="font-medium text-gray-800">{name}</span>
                          </div>
                        </td>

                        <td className="px-5 py-3.5 text-gray-500 max-w-[200px]">
                          <span className="truncate block">{getEmail(user)}</span>
                        </td>
                         <td className="px-5 py-3.5 text-gray-500 max-w-[200px]">
                          <span className="truncate block">{user?.phone ? user?.phone : '-'}</span>
                        </td>
   
                        <td className="px-5 py-3.5 w-[150px]">
                          <span className={PLAN_BADGE_CLASS} style={{ color, backgroundColor: bg }}>
                            {getDisplayLabel(user?.planName) || 'Free'}
                          </span>
                        </td>
                     

                        <td className="px-5 py-3.5">
                          <span className={`font-medium ${statusStyle[status] || "text-gray-500"}`}>
                            {status}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 text-gray-500 whitespace-nowrap">{getLastActive(user)}</td>
                        <td className="px-5 py-3.5 text-gray-500 whitespace-nowrap">{getJoined(user)}</td>
                        <td className="px-5 py-3.5">
                          <button onClick={() => handleNavigateView(user)} className="text-xs border border-gray-200 text-gray-500 rounded px-3 py-1.5 hover:border-blue-300 hover:text-blue-600 hover:bg-blue-50 transition-colors font-medium">
                            View
                          </button>
                        </td>
                      </tr>
                    );
                  })
              )}
            </tbody>
          </table>
        </div>
        {activeTab === 'All' &&
          <div className="flex items-center justify-between mt-3">
            <p className="text-xs text-gray-400">
              Showing {(page - 1) * rowsPerPage + 1}–{Math.min(page * rowsPerPage, pageCount)} of {pageCount} users
            </p>

            {totalPages > 1 && (
              <div className="flex items-center gap-1">
                <button
                  onClick={() => setPage((p) => Math.max(1, p - 1))}
                  disabled={page === 1}
                  className="px-3 py-1.5 text-xs border border-gray-200 rounded hover:border-blue-300 hover:text-blue-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                >
                  ← Prev
                </button>

                {getPaginationPages().map((p, i) =>
                  p === "…" ? (
                    <span key={`ellipsis-${i}`} className="px-2 text-gray-400 text-xs">…</span>
                  ) : (
                    <button
                      key={p}
                      onClick={() => setPage(p)}
                      className={`px-3 py-1.5 text-xs border rounded transition-colors ${page === p
                        ? "border-blue-500 bg-blue-500 text-white"
                        : "border-gray-200 text-gray-500 hover:border-blue-300 hover:text-blue-600"
                        }`}
                    >
                      {p}
                    </button>
                  )
                )}

                <button
                  onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                  disabled={page === totalPages}
                  className="px-3 py-1.5 text-xs border border-gray-200 rounded hover:border-blue-300 hover:text-blue-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
                >
                  Next →
                </button>
              </div>
            )}
          </div>}

      </div>
    </Page>
  );
}